import { format, startOfMonth } from 'date-fns'
import { makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'
import type { SmsCollection } from '../Sms'

export class PaymentMessageStatus extends DTO {
  base: {
    startDate: Date | null
    endDate: Date | null
    payDay: number | null
  } = {
    startDate: null,
    endDate: null,
    payDay: null,
  }
  summary = {
    smsCount: 0,
    lmsCount: 0,
    smsFee: 0,
    lmsFee: 0,
  }
  messageColl?: SmsCollection
  payStartYearMonth: string = new Date().toDateString()

  constructor(data: {
    base: res.PaymentMessageStatus['base']
    summary: res.PaymentMessageStatus['summary']
    messageColl: SmsCollection
  }) {
    super()

    makeObservable(this, {
      base: observable,
      summary: observable,
      messageColl: observable,
    })

    if (data) {
      this.base = {
        startDate: new Date(data.base.startDate),
        endDate: new Date(data.base.endDate),
        payDay: data.base.payDate,
      }
      this.summary = data.summary
      this.messageColl = data.messageColl
    }
  }

  get totalFee() {
    return this.summary.smsFee + this.summary.lmsFee
  }
  get formattedStartDate() {
    if (!this.base.startDate) return null
    return format(new Date(this.base.startDate), 'yyyy.MM.dd')
  }
  get formattedEndDate() {
    if (!this.base.endDate) return null
    return format(new Date(this.base.endDate), 'yyyy.MM.dd')
  }
  get payDayOfMonth() {
    return this.base.payDay
  }
  get formattedPayStartYearMonth() {
    const [year, month] = this.payStartYearMonth.split('-')
    return startOfMonth(new Date(Number(year), Number(month) - 1))
  }
}
